import React, { CSSProperties, useState } from "react";
import { Drawer, DrawerProps } from "@mui/material";
import { noop } from "../../Helpers/Utilities";

interface DrawerProviderProps extends Omit<DrawerProps, "open"> {}
interface DrawerOptions extends DrawerProviderProps { style?: CSSProperties}
type ProviderContext = readonly [(options: DrawerOptions) => void, () => void];
const DrawerContext = React.createContext<ProviderContext>([noop, noop]);
interface DrawerContainerProps extends DrawerProps {
}
function DrawerContainer(props?: DrawerContainerProps) {
  return (
    <>
      {props && (
        <Drawer
          open={props.open}
          className={props.className}
          style={props.style}
          variant={props.variant}
          anchor={props.anchor}
        >
          {props.children}
        </Drawer>
        )}
    </>
  )
}


export default function DrawerProvider(props: DrawerProviderProps) {
  const [content, setContent] = useState<DrawerProps>();
  const openDrawer = (options: DrawerOptions) => {
    setContent({
      ...options,
      open: true
    })
  }
  const closeDrawer = () => {
    setContent({
      ...content,
      open: false
    })
  }
  const contextValue = React.useRef([openDrawer, closeDrawer] as const);
  return (
    <DrawerContext.Provider value={contextValue.current}>

        {props.children}
        <DrawerContainer
          {...content}
          onClose={closeDrawer}
        />

    </DrawerContext.Provider>
  )
}

export const useDrawer = () => React.useContext(DrawerContext);